import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { LastLocationProvider } from 'react-router-last-location';
import { ToastContainer } from 'react-toastify';

import Privacy from '../../pages/Privacy/Privacy';
import Terms from '../../pages/Terms/Terms';
import Covid from '../../pages/Covid/Covid';
import Layout from '../Layout/Layout';

import { fetchSettings } from '@redux/actions';

import moment from 'moment-timezone';

moment.updateLocale('en', {
	week: {
		dow: 1,
	},
});

import './image-gallery.css';
import './App.css';

function App() {
	const dispatch = useDispatch();
	const [ready, setReady] = useState(false);

	useEffect(() => {
		(async () => {
			await fetchSettings().then(dispatch);
		})();
	}, [dispatch]);

	const timezone = useSelector(state => state.settings.timezone);
	useLayoutEffect(() => {
		if (!timezone?.key) { return; }
		moment.tz.setDefault(timezone.key);
		setReady(true);
	}, [timezone?.key]);

	if (!ready) { return null; }

	return (
		<BrowserRouter basename="/book/3">
			<LastLocationProvider>
				<Switch>
					<Route path="/privacy" exact component={Privacy} />
					<Route path="/terms" exact component={Terms} />
					<Route path="/covid" exact component={Covid} />
					<Route component={Layout} />
				</Switch>
				<ToastContainer />
			</LastLocationProvider>
		</BrowserRouter>
	);
}

export default App;
